export default "__VITE_ASSET__B4DplJ$n__"